export const legalIt = {
  company: {
    name: 'MULTI SERVICE S.R.L.S.',
    dba: ['SynthoHosting', 'Syntho.Network', 'SynthoNetwork', 'SynthoGuard', 'Minefence', 'Multi Service Società a Responsabilità Limitata Semplificata'],
    address: 'Via Isonzo 102, Racale (LE), 73055, Italia',
    vat: 'IT 05316380756',
    rea: 'LE - 358063',
    phone: '+3909841800706',
    email: 'amministrativo@synthohosting.net',
    website: 'synthohosting.net'
  },
  terms: {
    title: 'Termini di Servizio',
    lastUpdated: 'Ultimo Aggiornamento: Marzo 2024',
    introduction: 'Questi Termini Legali costituiscono un accordo legalmente vincolante tra te, sia personalmente che per conto di un\'entità ("tu"), e MULTI SERVICE S.R.L.S., riguardo il tuo accesso e utilizzo dei Servizi. Accetti che accedendo ai Servizi, hai letto, compreso e accettato di essere vincolato da tutti questi Termini Legali. SE NON ACCETTI TUTTI QUESTI TERMINI LEGALI, TI È ESPRESSAMENTE VIETATO UTILIZZARE I SERVIZI E DEVI INTERROMPERE IMMEDIATAMENTE L\'UTILIZZO.',
    sections: [
      {
        title: '1. Termini di Vendita',
        content: 'Tutti i clienti di SynthoHosting sono tenuti a rispettare i termini di servizio. È responsabilità del cliente rimanere informato su eventuali modifiche future.'
      },
      {
        title: '2. Durata del Contratto',
        content: 'I clienti possono terminare i servizi SynthoHosting in qualsiasi momento informandoci attraverso l\'area clienti dell\'intenzione di cancellare il servizio. Tuttavia, la durata del contratto è legata al periodo di fatturazione, e se il cliente decide di terminare prima, perderà i giorni/mesi/anni rimanenti, e il pagamento non è rimborsabile.'
      },
      {
        title: '3. Responsabilità del Provider',
        content: 'SynthoHosting non si assume alcuna responsabilità per eventuali danni, accidentali o consequenziali. È responsabilità del cliente proteggere i dati ospitati sui servizi SynthoHosting in un luogo sicuro.'
      },
      {
        title: '4. Pagamenti e Fatture',
        content: 'Tutti i servizi SynthoHosting sono fatturati in base alle date di attivazione. I pagamenti non sono rimborsabili dopo 74 ore dall\'attivazione del prodotto. I pagamenti possono essere effettuati solo tramite Stripe, Paypal o Bonifico Bancario. La fatturazione avviene solo negli intervalli: Mensile, Trimestrale, Semestrale, Annuale, Biennale e Triennale. SynthoHosting ha il diritto di sospendere e/o terminare i servizi per controversie sui pagamenti. Il saldo dell\'account non è trasferibile tra clienti.'
      },
      {
        title: '5. Rinnovi',
        content: 'Dopo la data di scadenza del servizio su SynthoHosting, è possibile rinnovare il servizio entro 5 giorni; se il pagamento non viene effettuato, il servizio sarà eliminato dopo 7 giorni.'
      },
      {
        title: '6. Terminazione',
        content: 'Per terminare il contratto con SynthoHosting, è necessario accedere all\'area clienti disponibile su my.synthohosting.net e cliccare il pulsante di cancellazione, specificando la data di terminazione e il motivo (opzionale).'
      },
      {
        title: '7. Service Level Agreement (SLA)',
        content: 'Garanzie di Service Level Agreement mensile:\n- Servizi VPS: 95,00%\n- Server Dedicati: 97,95%\n- Transit Protetto: 98,95%\n- Transit Non Protetto: 98,00%\n- Tutti gli altri servizi: 90,00%\n\nIl compenso per violazioni SLA è fornito esclusivamente come estensione del servizio. I clienti accettano di utilizzare i servizi a proprio rischio e SynthoHosting non è responsabile per perdita di dati o altri danni.'
      },
      {
        title: '8. Diritti',
        content: 'È vietato qualsiasi materiale illegale o che violi i diritti di terzi ospitato sui server SynthoHosting. SynthoHosting si riserva il diritto di sospendere il servizio in qualsiasi momento.'
      },
      {
        title: '9. Informazioni Cliente',
        content: 'Tutti i clienti devono fornire dati personali completi e accurati. Qualsiasi abuso di informazioni inventate comporterà la sospensione dell\'account. In conformità con il Decreto Legislativo italiano n. 70 del 9 aprile 2003, MULTI SERVICE S.R.L.S. si riserva il diritto di richiedere la verifica dell\'identità e utilizzare piattaforme di terze parti per la verifica.'
      },
      {
        title: '10. Contenuti Proibiti',
        content: 'Sono severamente vietati:\n- Contenuti illegali, dannosi o offensivi\n- Script nulled\n- Torrent illegali\n- Server proxy pubblici/VPN\n- SPAM\n- TOR\n- Pagine di phishing\n- Script Slowloris\n- Attività DoS/DDoS\n- Script ad alto consumo CPU (mining Bitcoin, bot)\n- Distribuzione illegale di materiale protetto da copyright\n- Pornografia infantile\n- Utilizzo CPU superiore al 90% continuativamente'
      },
      {
        title: '11. Fair Usage Policy',
        content: 'La banda è fornita su base fair use con una soglia di 5TB/mese. I clienti che superano questo limite saranno contattati per organizzare l\'utilizzo futuro della banda tramite un preventivo BMG.'
      },
      {
        title: '12. Protezione DDoS',
        content: 'La protezione DDoS di SynthoHosting è stata testata con una protezione nominale fino a 88 Tb/s. Garantiamo una protezione fino a 4 Tb/s.'
      }
    ]
  },
  privacy: {
    title: 'Informativa sulla Privacy',
    lastUpdated: 'Ultimo Aggiornamento: Marzo 2024',
    sections: [
      {
        title: '1. Raccolta Dati',
        content: 'Raccogliamo le informazioni personali necessarie per la fornitura del servizio e la gestione dell\'account, inclusi nome, email, informazioni di fatturazione e dati di utilizzo del servizio.'
      },
      {
        title: '2. Utilizzo dei Dati',
        content: 'I dati raccolti vengono utilizzati per l\'erogazione del servizio, la comunicazione, la fatturazione e la conformità legale. Non vendiamo né condividiamo i dati personali se non quando necessario per la fornitura del servizio.'
      },
      {
        title: '3. Protezione dei Dati',
        content: 'Implementiamo misure di sicurezza standard del settore inclusi crittografia, firewall e audit di sicurezza regolari.'
      },
      {
        title: '4. I Tuoi Diritti',
        content: 'Hai il diritto di accedere, correggere o eliminare i tuoi dati personali. Contatta il nostro team di supporto per esercitare questi diritti.'
      }
    ]
  },
  cookies: {
    title: 'Policy sui Cookie',
    lastUpdated: 'Ultimo Aggiornamento: Marzo 2024',
    sections: [
      {
        title: '1. Cosa Sono i Cookie',
        content: 'I cookie sono piccoli file di testo memorizzati sul tuo dispositivo per migliorare la funzionalità del sito web e l\'esperienza utente.'
      },
      {
        title: '2. Tipi di Cookie',
        content: 'Utilizziamo cookie essenziali per le funzionalità di base e cookie analitici per migliorare i nostri servizi. Potrebbero essere utilizzati anche cookie di terze parti per analisi e marketing.'
      },
      {
        title: '3. Controllo dei Cookie',
        content: 'Puoi controllare le preferenze dei cookie attraverso le impostazioni del tuo browser. Nota che la disabilitazione di alcuni cookie potrebbe influire sulla funzionalità del sito.'
      }
    ]
  }
}